export default __webpack_public_path__ + "static/media/bikiran-banner-1.7c84e5ab.png";